import { render, staticRenderFns } from "./InputQuizset.vue?vue&type=template&id=97d5b8dc&scoped=true&"
import script from "./InputQuizset.vue?vue&type=script&lang=js&"
export * from "./InputQuizset.vue?vue&type=script&lang=js&"
import style0 from "./InputQuizset.vue?vue&type=style&index=0&id=97d5b8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d5b8dc",
  null
  
)

export default component.exports